export const SERVICE_TESTIMONIALS = [
  {
    quote:
      "Our garage floor was a mess of oil stains and salt damage. MLC Epoxy Floors ground it down, fixed every crack, and laid a flake floor that looks better than the inside of our house.",
    name: "Mark R.",
    city: "Airdrie, AB",
    stars: 5,
  },
  {
    quote:
      "Worth every dollar. Hot tires, road salt, motor oil — nothing fazes it. Crew was in and out in a single day and the workmanship is incredible.",
    name: "Janelle T.",
    city: "Calgary, MD",
    stars: 5,
  },
  {
    quote:
      "Two winters in and not a single chip or peel. Best upgrade we've made to the house. The polyaspartic finish still looks brand new.",
    name: "Doug & Pat M.",
    city: "Falls Church, VA",
    stars: 5,
  },
];
